export const getLocalTime = (timeZone: string): string => {
    return new Date().toLocaleString('en-US', { timeZone, hour: 'numeric', minute: '2-digit', hour12: true });
};
